module.exports = __webpack_public_path__ + "img/event-icon.49e2486e.svg";